import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../core/api/auth.guard';
import { BasicLayoutComponent } from '../layout/basic-layout.component';
import { AuthModule } from './auth/auth.module';

const routes: Routes = [
  {
    path: '',
    component: BasicLayoutComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
      { path: '', redirectTo: 'patient/new-list', pathMatch: 'full' },
      { path: 'patient', loadChildren: () => import('./patient/patient.module').then((m) => m.PatientModule), data: { title: 'ホーム' } },
      { path: 'setting', loadChildren: () => import('./setting/setting.module').then((m) => m.SettingModule), data: { title: 'アカウント' } },
    ],
  },
  { 
    path: 'survey',
    canLoad: [AuthGuard],
    loadChildren: () => import('./survey/survey.module').then((m) => m.SurveyModule), 
  },
  { path: 'auth', loadChildren: () => AuthModule },
];

@NgModule({
  imports: [RouterModule.forRoot(routes,
    {
      enableTracing: false, // <-- debugging purposes only
    })
  ],
  exports: [RouterModule]
})

export class RoutesRoutingModule { }
